import { injectReducer } from "store/reducers";
import {
  TeacherResources,
  TeacherPolicy,
  ParentPolicy,
  AdminResources,
  WorkbookResources,
  StudentResources,
  ParentResources,
  StudentPolicy,
} from "OrganizationResources";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "educatorcenter",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "organization-educatorCenter" */ "./components"
        ),
        import(
          /* webpackChunkName: "organization-educatorCenter" */ "./modules/AdminEducatorCenterModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "educatorCenter",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    TeacherResources(store),
    TeacherPolicy(store),
    ParentPolicy(store),
    AdminResources(store),
    StudentResources(store),
    ParentResources(store),
    WorkbookResources(store),
    StudentPolicy(store),
  ],
});
